export default [
  {
    title: 'Are you sure?',
    body: 'We definitely need to ask users more times',
    cancel: 'No',
    accept: 'Yes',
  },
  {
    title: 'Would you like another modal?',
    body: '',
    cancel: 'Escape',
    accept: 'Keep em comin',
  },
  {
    title: 'I enjoy doing bad things',
    body: '',
    cancel: 'Fold',
    accept: 'Hit me',
  },
  {
    title: 'Confirmation',
    body: 'But we really need a confirmation screen',
    cancel: "You don't",
    accept: "You're right",
  },
  {
    title: 'Loading...',
    body: '',
    cancel: 'Stop important task',
    accept: 'Go faster',
  },
  {
    title: 'Another modal?',
    body: 'Seriously?',
    cancel: `Ok I\'m done`,
    accept: 'I want more',
  },
];
